import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FILE_CONTENT_TYPE, fileMaxSize10MB } from '@/features/shared/constants';

type TooltipError = {
  color: string;
  message: string;
  isInfo: boolean;
  isError: boolean;
  backgroundColor: string;
};

export const useFileTooltipError = () => {
  const { t } = useTranslation('borderCrossingRORO_onBoarding');
  const [fileTooltipError, setFileTooltipError] = useState<Partial<TooltipError>>({
    isError: false,
    isInfo: false,
  });

  const getFileTooltipError = (file: File) => {
    if (!checkIsFileTypeValid(file)) {
      setFileTooltipError({
        isError: true,
        isInfo: false,
        color: 'error.main',
        backgroundColor: 'error.light',
        message: t('borderCrossingRORO.onBoarding.subscribeAdditionnalInformation.form.pdfFileTypesAndSize.label'),
      });
    }

    if (file?.size > fileMaxSize10MB) {
      setFileTooltipError({
        isError: true,
        isInfo: false,
        color: 'error.main',
        backgroundColor: 'error.light',
        message: t(
          'borderCrossingRORO.onBoarding.subscribeAdditionnalInformation.form.uploadFile.fileTooLarge.message',
        ),
      });
    }
  };

  const checkIsFileTypeValid = (newFile: File) => newFile.type === FILE_CONTENT_TYPE.PDF;
  //  || newFile.type === FILE_CONTENT_TYPE.PNG ||
  //   newFile.type === FILE_CONTENT_TYPE.JPEG;

  return { fileTooltipError, getFileTooltipError, checkIsFileTypeValid };
};
